import { render, staticRenderFns } from "./ShipmentTable.vue?vue&type=template&id=cec91b5e&"
import script from "./ShipmentTable.vue?vue&type=script&lang=js&"
export * from "./ShipmentTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShipmentTable.vue"
export default component.exports